import { render, staticRenderFns } from "./NxSigningModalMethodP12.vue?vue&type=template&id=0879af02&scoped=true&"
import script from "./NxSigningModalMethodP12.vue?vue&type=script&lang=js&"
export * from "./NxSigningModalMethodP12.vue?vue&type=script&lang=js&"
import style0 from "./NxSigningModalMethodP12.vue?vue&type=style&index=0&id=0879af02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879af02",
  null
  
)

export default component.exports